import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, ProgressBar, Textarea } from '@salesforce/design-system-react';

const milestoneColors = {
  trigger: 'milestone-idea-background-1',
  key: 'milestone-idea-background-3',
  guide: 'milestone-idea-background-2',
  crisis: 'milestone-idea-background-4',
  triumph: 'milestone-idea-background-5',
  Responsibility: 'milestone-idea-background-2',
  Pain: 'milestone-idea-background-5',
  Goal: 'milestone-idea-background-3',
};

const AddIdea = (props) => {
  return (
    <React.Fragment>
      <Card
        className="slds-m-top_x-small"
        heading={
          <span
            style={{ textTransform: 'capitalize', fontWeight: '400', fontSize: '20px', color: '#3c4043' }}
          >{props.milestone === "Responsibility" ? 'Relevant Information' : `${props.milestone} Sticky Note`}</span>
        }
      >
        <div className="slds-m-top_large">
          <ProgressBar id="progress-bar-success" value={((props.value.length) / 255 * 100)} />
          <Textarea
            maxLength="255"
            assistiveText={{ label: 'Content' }}
            value={props.value}
            onChange={props.onChange}
            className={props.connectors ? 'potential-milestone-connector' : milestoneColors[props.milestone]}
          />
          <div className="slds-clearfix">
            <div className="slds-float_right">
              <Button
                label="Cancel"
                variant="base"
                onClick={props.onCancelButtonClick}
                className="slds-m-vertical_small slds-m-right_small"
              />
              <Button
                label="Save"
                variant="brand"
                onClick={props.onAdd}
                className="slds-m-vertical_small slds-m-right_small"
              />
            </div>
          </div>
        </div>
      </Card>
    </React.Fragment>
  );
};

AddIdea.propTypes = {
  milestone: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddIdea;
